import { render, staticRenderFns } from "./CeremonyController.vue?vue&type=template&id=283b05a4&scoped=true"
import script from "./CeremonyController.vue?vue&type=script&lang=js"
export * from "./CeremonyController.vue?vue&type=script&lang=js"
import style0 from "./CeremonyController.vue?vue&type=style&index=0&id=283b05a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b05a4",
  null
  
)

export default component.exports